"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.URL_HELPER = void 0;
exports.includeJs = includeJs;
exports.waitForElement = waitForElement;
var URL_HELPER = exports.URL_HELPER = {
  get baseURL() {
    return window.location.origin;
  }
};

/**
 * Wait for an element before resolving a promise
 * @param {String} querySelector - Selector of element to wait for
 * @param {Integer} timeout - Milliseconds to wait before timing out, or 0 for no timeout
 */
function waitForElement(querySelector, timeout) {
  return new Promise(function (resolve, reject) {
    var timer = false;
    if (document.querySelectorAll(querySelector).length) return resolve();
    var observer = new MutationObserver(function () {
      if (document.querySelectorAll(querySelector).length) {
        observer.disconnect();
        if (timer !== false) clearTimeout(timer);
        return resolve();
      }
    });
    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
    if (timeout) {
      timer = setTimeout(function () {
        observer.disconnect();
        reject();
      }, timeout);
    }
  });
}
function includeJs(jsFilePath) {
  var js = document.createElement("script");
  js.type = "text/javascript";
  js.src = jsFilePath;
  document.body.appendChild(js);
}